import { Line, Bar } from 'vue-chartjs'

export default {
  mixins: [Line, Bar],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    }
  }
}
